import { default as React, useEffect } from "react"
import { Row } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { Header } from "../../common/headers"
import SideBar from "../../common/layout/sidebar.component"
import IntlProps from "../../state/helpers/IntlProps"
import { CREATE_NEW_STOCK_LOCATION_PAGE_MESSAGES } from "../../utils/inventory"
import StockLocationForm from "../forms/StockLocationForm"


const CreateStockLocationPage = (props: IntlProps) => {
    useEffect(() => {
        SideBar.activateMenu("inventory")
    }, [])

    return (
        <div className="mb-4">
            <Row className="ui-has-modules">
                <div className="col-8">
                    <Header title={props.intl.formatMessage(CREATE_NEW_STOCK_LOCATION_PAGE_MESSAGES["mainLabel"])}/>
                </div>
            </Row>
            <StockLocationForm/>
        </div>
    )

}

export default injectIntl(CreateStockLocationPage)


// WEBPACK FOOTER //
// ./src/inventory/pages/CreateStockLocationPage.tsx